<template>

  <h1 v-if="!pokemon">Por favor espere...</h1>

  <div v-else>
    <h1>Quien es este pokemon?</h1>
  
    <PokemonPicture :pokemonId="pokemon.id" :showPokemon="showPokemon" />
    <PokemonOption :pokemons="pokemonsArr" @selection="checkAnswer" :disabled="disable" />

    <template v-if="showAnswer" class="fade-in">
      <h1>{{ message }}</h1>
      <button class="btn-newgame" @click="newGame">Nuevo Juego</button>
    </template>

  </div>
</template>

<script>
import PokemonPicture from '../components/PokemonPicture.vue'
import PokemonOption from '../components/PokemonOption.vue'
import getPokemonOptions from '../helpers/getPokemonOpcionts'


export default {
  components: { 
    PokemonPicture, 
    PokemonOption
  },
  data (){
    return {
      pokemonsArr: [],
      pokemon: null,
      showPokemon: false,
      showAnswer: false,
      message: '',
      disabled: false
    }
  },
  methods: {
    async mixPokemonArray () {
      this.pokemonsArr = await getPokemonOptions()
      const rndInt = Math.floor(Math.random() * 4)
      this.pokemon = this.pokemonsArr[rndInt]
    },
    checkAnswer(pokemonId) {
      this.showPokemon =  true
      this.showAnswer = true

      if(pokemonId === this.pokemon.id){
        this.message = `Correto, es ${this.pokemon.name}`
      } else {
        this.message = `Opps, era ${this.pokemon.name}`
      }
    },
    newGame(){
      this.showPokemon = false
      this.showAnswer = false
      this.pokemonsArr = []
      this.mixPokemonArray()
    }
  },

  mounted() {
    this.mixPokemonArray()
  }

}
</script>

<style scoped>
  .btn-newgame{
    width: 250px;
    height: 80px;
    border: 1px solid chartreuse;
    outline: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: bold;
    border-radius: 5px;
  }

  .btn-newgame:hover{
    color: white;
    background-color: chartreuse;
  }
</style>